import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output, QueryList,
  SimpleChanges,
  ViewChild, ViewChildren
} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import { Observable, Subject } from 'rxjs';
import {tap, debounceTime, switchMap, finalize} from 'rxjs/operators';
import { ExcRestService } from 'exc-rest-v2';
import { ExgApplicationTabService } from 'exc-tab-v2';
import { ExcSecurityService } from 'exc-security-v2';
import { ExgModalService } from 'exc-controls-v2';
import { EnumerationService } from '../../services/enumeration.service';
import { ApplicationService } from '../../services/application.service';
import { DataService } from '../../services/data.service';
import {IExcDataSort} from 'exc-rest-v2/lib/interfaces/IExcDataSort';
import {IExcDataPaging} from 'exc-rest-v2/lib/interfaces/IExcDataPaging';
import {IExcDataFilter} from 'exc-rest-v2/lib/interfaces/IExcDataFilter';

@Component({
  selector: 'app-exg-type-ahead-input',
  templateUrl: './exg-type-ahead-input.component.html',
  styles: []
})
export class ExgTypeAheadInputComponent extends ExcTranslation implements OnInit, OnChanges {
  @ViewChild('inputElement') inputElement!: ElementRef;
  @ViewChild('showMore') showMore!: ElementRef;
  @ViewChildren('listRow') listRows!: QueryList<ElementRef>;
  @Input() listdisplay = '';
  @Input() listCall = '';
  @Input() listMetaInfo = {
    dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
    dataSort: {} as IExcDataSort,
    dataFilter: {} as IExcDataFilter
  };
  @Input() searchPlaceholder = 'Suche';
  @Input() outputAttribute = '';
  @Input() pObj: { [key: string]: any } = {};
  @Input() insertReturnValue = undefined;
  @Input() deleteIsLocked = false;
  @Input() isLocked = false;

  @Output() choseObj = new EventEmitter<any>();
  @Output() deleteChosenObj = new EventEmitter<any>();
  @Output() insertedReturnValue = new EventEmitter<any>();

  /* Search Value */
  private _searchValue = '';
  private searchSubject = new Subject<string>();  // To track search input changes
  get searchValue(): string {
    return this._searchValue;
  }

  set searchValue(value: string) {
    if (!value) {
      this._searchValue = '';
      this.data.maxResultCount = 5;
      this.data.data = [];
      this.data.showResults = true;
    }
    else {
      this._searchValue = value;
      this.searchSubject.next(value);  // Emit value to the subject
      this.data.showResults = true;
    }
  }

  /* Return Value */
  returnValue: any = undefined;

  /* Data from DB & Functions */

  /* Data from DB & Functions */
  data = {
    data: [] as any[],
    state: 0,  // 0 = data loaded, 1 = loading, 2 = no data or error
    showResults: true,
    maxResultCount: 5,

    loadDataObs: (pObj: any = this.pObj): Observable<any> => {
      this.data.state = 1;  // Set to loading state before API call
      return this.excRest.sget(this.excRest.computeUrl(this.listCall, pObj),
        ExcCoreModule.Guid.NewGuid(),
        {MetaInfo: this.listMetaInfo}).pipe(
        tap((response: any) => {
          if (response?.success && response?.data?.length > 0) {
            this.data.data = response.data;
            this.data.state = 0;  // Set to data loaded state
          } else if (response?.success && response?.data?.length === 0) {
            this.data.data = [];  // Clear data if no results
            this.data.state = 2;  // Set to no data state
          } else {
            this.data.data = [];  // Clear data if no results
            this.data.state = 2;  // Set to no data state
            this.modal.showToast('Daten konnten nicht geladen werden.', 'md-toast', 'fal fa-exclamation');
          }
        }),
        finalize(() => {
          if (this.data.state === 1) {
            // If still in loading state after request, we know there was no data
            this.data.state = 2;
          }
        })
      );
    }
  };

  constructor(
    private exgApplicationTabService: ExgApplicationTabService,
    public excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modal: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    private dataSvc: DataService) {
    super();
  }

  ngOnInit(): void {
    // Subscribe to searchValue changes with debounce and distinct check
    this.searchSubject.pipe(
      debounceTime(300),  // Wait for 300ms pause in events
      switchMap((searchText) => {
        this.pObj.fts = searchText;  // Add searchText to pObj
        return this.data.loadDataObs();  // Execute the call
      })
    ).subscribe((ret: any) => {
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.insertReturnValue) {
      if (changes.insertReturnValue.currentValue) {
        this.returnValue = changes.insertReturnValue.currentValue;
        this.searchValue = '';
        if (this.outputAttribute) {
          this.insertedReturnValue.emit(this.returnValue[this.outputAttribute]);
        }
        else {
          this.insertedReturnValue.emit(this.returnValue);
        }
      }
      else {
        this.returnValue = undefined;
        this.searchValue = '';
      }
    }
    if (changes?.isLocked) {
      this.searchValue = '';
    }
  }
  deleteSearchValue(): void {
    this.searchValue = '';
  }

  deleteChosenObject(): void {
    if (!this.deleteIsLocked) {
      this.data.maxResultCount = 5;
      this.returnValue = undefined;
      this.data.showResults = true;
      this.deleteChosenObj.emit();
    }
  }

  onShowMore(): void {
    this.data.maxResultCount = 25;
    this.listRows.toArray()[4].nativeElement.focus();
  }

  onResultClick(item: any): void {
    this.data.showResults = false;
    this.returnValue = item;
    /*If an Output Attribut is chosen it will be returned*/
    if (this.outputAttribute) {
      this.choseObj.emit(this.returnValue[this.outputAttribute]);
    }
    else {
      this.choseObj.emit(this.returnValue);
    }
  }

  onArrowUp(event: any, index: number): void {
    event.preventDefault(); // Verhindert das Scrollen der Seite
    if (index > 0) {
      this.listRows.toArray()[index - 1].nativeElement.focus();
    }
    if (index === 0) {
      this.inputElement.nativeElement.focus();
    }
  }

  onArrowDown(event: any, index: number): void {
    event.preventDefault(); // Verhindert das Scrollen der Seite
    if (index < this.listRows.length - 1) {
      this.listRows.toArray()[index + 1].nativeElement.focus();
    }
    if (index === this.data.maxResultCount - 1) {
      this.showMore.nativeElement.focus();
    }
  }
}
